<template>
  <div class="data-summary-container">
    <!-- 左侧数据区 -->
    <div class="data-group">
      <div class="data-item">
        <div class="data-value">{{supplyCompany}}<span class="data-unit">家</span></div>
        <div class="data-label">保供公司</div>
      </div>
      <div class="data-item">
        <div class="data-value">{{materialTon}}<span class="data-unit">吨</span></div>
        <div class="data-label">物资</div>
      </div>
    </div>

    <!-- 右侧数据区 -->
    <div class="data-group">
      <div class="data-item">
        <div class="data-value">{{serviceCompany}}<span class="data-unit">家</span></div>
        <div class="data-label">服务公司</div>
      </div>
      <div class="data-item">
        <div class="data-value">{{areaMu}}<span class="data-unit">亩/次</span></div>
        <div class="data-label">面积</div>
      </div>
    </div>
  </div>
</template>

<script>
import {getStoreCount} from "@/API/chinaMapApi/chinaMapApi";

export default {
  name: 'DataSummaryCard',
  data(){
    return{
      supplyCompany:0 ,
      materialTon:0,
      serviceCompany:0,
      areaMu: 0,
    }
  },
  mounted() {
    this.getAmount1();
    this.getAmount2();
  },
  methods: {
    getAmount1() {
      let params = {
        region: this.$store.state.chinaMap.currentlyMapAdcode,
        types: '1,3',
        subId: this.$store.state.chinaMap.timeId,
        dataType: this.$store.state.chinaMap.currentlyMapAdcode
            ? this.$store.state.chinaMap.dataType
            : '',
        companyId: this.$store.state.chinaMap.companyId,
      };
      getStoreCount(params).then((res) => {
        if (res.code === 200) {
          this.supplyCompany = res.data.count || 0;
          this.materialTon = Number(res.data.sum || 0).toFixed(3);
        }
      });
    },
    getAmount2() {
      let params = {
        region: this.$store.state.chinaMap.currentlyMapAdcode,
        types: '2,3',
        subId: this.$store.state.chinaMap.timeId,
        dataType: this.$store.state.chinaMap.currentlyMapAdcode
            ? this.$store.state.chinaMap.dataType
            : '',
        companyId: this.$store.state.chinaMap.companyId,
      };
      getStoreCount(params).then((res) => {
        if (res.code === 200) {
          this.serviceCompany = res.data.count || 0;
          this.areaMu = Number(res.data.sum || 0).toFixed(3);
        }
      });
    },
  },
};
</script>

<style scoped>
/* 外层容器：100%继承父组件宽高 */
.data-summary-container {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: space-around;
  padding: 20px;
  box-sizing: border-box;
}

/* 左右数据组：垂直排列两个数据项 */
.data-group {
  display: flex;
  flex: 1;
  align-items: center;
  justify-content: center;
  gap: 40px; /* 两个数据项之间的间距 */
}

/* 单个数据项：数字+单位+标签 */
.data-item {
  text-align: center;
}

/* 数值样式（大字体+加粗） */
.data-value {
  font-size: 36px;
  font-weight: bold;
  color: #ffffff;
  line-height: 1.2;
}

/* 单位样式（小字体+浅灰色） */
.data-unit {
  font-size: 12px;
  color: #c7c9ce;
  margin-left: 4px;
}

/* 标签样式（中等字体+更浅灰色） */
.data-label {
  font-size: 14px;
  color: #c7c9ce;
  margin-top: 8px;
}
</style>
